<script lang="ts">
    import { useNavigate } from "svelte-navigator";
    import { beforeUpdate, onMount } from "svelte";
    import Chart from "chart.js/auto";
    import dayjs from "dayjs";
    import { rangeObject } from "../../../../../Types/Stats";

    export let id;
    export let title;
    export let labels: string[];
    export let dataset: any[];
    export let range: rangeObject;
    let myChart;
    beforeUpdate(() => {
        if (myChart && labels && dataset) {
            myChart.data.datasets.forEach((data, index) => {
                data.data = dataset[index].data;
            });
            myChart.data.labels = labels;
            myChart.update();
        }
    });

    let width, height, gradient;
    function getGradient(ctx, chartArea) {
        const chartWidth = chartArea.right - chartArea.left;
        const chartHeight = chartArea.bottom - chartArea.top;
        if (
            gradient === null ||
            width !== chartWidth ||
            height !== chartHeight
        ) {
            // Create the gradient because this is either the first render
            // or the size of the chart has changed
            width = chartWidth;
            height = chartHeight;
            gradient = ctx.createLinearGradient(
                0,
                chartArea.bottom,
                0,
                chartArea.top
            );
            gradient.addColorStop(1, "#14ACAB");
            gradient.addColorStop(0.5, "#238AAE");
            gradient.addColorStop(0, "#2765AF");
        }

        return gradient;
    }

    onMount(() => {
        const ctx = document.getElementById(id);
        myChart = new Chart(ctx as any, {
            type: "line",
            data: {
                labels: labels,
                datasets: dataset.map((dataset) => {
                    return {
                        ...dataset,
                        tension: 0.6,
                        fill: true,
                        backgroundColor: function (context) {
                            const chart = context.chart;
                            const { ctx, chartArea } = chart;

                            if (!chartArea) {
                                // This case happens on initial chart load
                                return null;
                            }
                            return getGradient(ctx, chartArea);
                        },
                    };
                }),
            },
            options: {
                scales: {
                    y: {
                        beginAtZero: true,
                        ticks: {
                            // For a category axis, the val is the index so the lookup via getLabelForValue is needed
                            callback: function (val: number, index) {
                                // Hide every 2nd tick label
                                return index % 3 === 0
                                    ? this.getLabelForValue(val)
                                    : "";
                            },
                        },
                    },
                    x: {
                        ticks: {
                            // For a category axis, the val is the index so the lookup via getLabelForValue is needed
                            callback: function (val: number, index) {
                                // Hide every 2nd tick label
                                return "";
                            },
                        },
                    },
                },
                interaction: {
                    intersect: false,
                },
            },
        });
    });
</script>

<div class="box">
    <div class="columns">
        <div class="column">
            <p class="subtitle is-5 left">{title}</p>
        </div>
        <div class="column">
            <p class="subtitle is-5 right">{range.start.format("DD.MM.YY")+" - "+range.end.format("DD.MM.YY")}</p>
        </div>
    </div>
    <div class="container">
        <div class="field has-addons has-addons-centered">
            <canvas {id} />
        </div>
    </div>
</div>

<style>
    .left {
        text-align: left;
    }

    .right {
        text-align: right;
    }
    .box {
        border-radius: 10px;
    }
</style>
